import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TransactionLog } from './transaction-logs';

@Injectable({
  providedIn: 'root'
})
export class TransactionLogService {
  constructor(private _http: HttpClient) {
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  public Post(log: TransactionLog) {
    var result = this._http.post(environment.urls.baseApiUrl + '/TransactionLogs', log)
      .pipe(
        catchError(this.handleError)
      );
    return result;
  }

  public UpdateStatus(logID: number) {
    return this._http.put(environment.urls.baseApiUrl + '/TransactionLogs/' + logID, null);
  }

  public GetBySerialNo(serialNo: string) {
    return this._http.get<TransactionLog[]>(environment.urls.baseApiUrl + '/TransactionLogs/BySerialNo/' + serialNo);
  }

  /** Loads dates containing transaction-log records for the Administration log viewer. */
  public GetDates(): Observable<{ date: string }[]> {
    return this._http.get<string[]>(environment.urls.baseApiUrl + '/TransactionLogs/Dates').pipe(
      map(dates => dates.map(date => ({ date })))
    );
  }

  /** Loads transaction-log records for one calendar date. */
  public GetByDate(date: string) {
    return this._http.get<TransactionLog[]>(environment.urls.baseApiUrl + '/TransactionLogs/ByDate/' + date);
  }

  public UpdateComments(logID: number, comments: string) {
    const t = { id: logID, objectJson: comments } as TransactionLog;
    return this._http.put(environment.urls.baseApiUrl + '/TransactionLogs/ChecklistBuilderComments', t);
  }
}
